import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../components/Loading/Loading";
import MemberPayments from "./MemberPayments"; 
import Header from "../../components/Header";
import { useAuth } from "../../context/Auth";
import MemberAccount from "./MemberAccount";
import { api_url } from "../../data";
import MemberPersonalDetails from "./MemberPersonalDetails";
import ProfileHeader from "../../components/MemberProfile/ProfileHeader";
import MemberFamilyInformation from "./MemberFamilyInformation";

const MemberProfile = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [gettingDetails, setGettingDetails] = useState(false);
  const { requestWithAuth } = useAuth();
  const { member_id } = useParams();
  const [memberDetails, setMemberDetails] = useState(null);
  const [familyDetails, setFamilyDetails] = useState(null);
  const [incomeTypes, setIncomeTypes] = useState([]);
  const [memberPayments, setMemberPayments] = useState([]); 
  const [gettingPayments, setGettingPayments] = useState(false); 

  
  const handleProfilePictureUpdate = (newProfilePictureUrl) => {
    setMemberDetails(prev => ({
      ...prev,
      profile_picture: newProfilePictureUrl
    }));
  };

  const getIncomeTypes = async () => {
    try {
      const response = await requestWithAuth(`/finance/income-types/`, "GET");
      setIncomeTypes(response);
    } catch (error) {
      toast.error("Failed to get income types");
    }
  };

  const getMemberDetails = async (member_id) => {
    try {
      setGettingDetails(true);
      const responseData = await requestWithAuth(
        `/members/${member_id}`,
        "GET",
        {
          "Content-Type": "application/json",
        }
      );
      setMemberDetails(responseData?.personal_information);
      setFamilyDetails(responseData?.family_information);
    } catch (error) {
      toast.error("Failed to get member details");
    } finally {
      setGettingDetails(false);
    }
  };

  // NEW: Get Member Payments
  const getMemberPayments = async (member_id) => {
    try {
      setGettingPayments(true);
      const responseData = await requestWithAuth(
        `/finance/member-payments/${member_id}/`, 
        "GET",
        {
          "Content-Type": "application/json",
        }
      );
      setMemberPayments(responseData);
    } catch (error) {
      console.error("Error fetching member payments:", error);
      toast.error("Failed to get member payments");
    } finally {
      setGettingPayments(false);
    }
  };

  useEffect(() => {
    getMemberDetails(member_id);
    getIncomeTypes();
  }, [member_id]); 

  
  useEffect(() => {
    if (activeTab === 5 && member_id) {
      getMemberPayments(member_id);
    }
  }, [activeTab, member_id]);

  return (
    <div>
      <Header title="Member Profile" />
      {gettingDetails ? (
        <Loading />
      ) : (
        <div className="border border-gray-300 rounded-lg">
          <ProfileHeader memberDetails={memberDetails} api_url={api_url} onProfilePictureUpdate={handleProfilePictureUpdate} />
          <div className="grid lg:grid-cols-4">
            <div className="px-3 py-4 lg:border-r border-gray-500 pr-3">
              <label htmlFor="" className="text-sm font-bold text-gray-400">
                Position
              </label>
              <p className="font-semibold">
                {memberDetails?.position || "N/A"}
              </p>
            </div>
            <div className="px-3 py-4 lg:border-r border-gray-500 pr-3">
              <label htmlFor="" className="text-sm font-bold text-gray-400">
                Email
              </label>
              <p className="font-semibold">{memberDetails?.email || "N/A"}</p>
            </div>
            <div className="px-3 py-4 lg:border-r border-gray-500 pr-3">
              <label htmlFor="" className="text-sm font-bold text-gray-400">
                Phone Number
              </label>
              <p className="font-semibold">
                {memberDetails?.phone_number || "N/A"}
              </p>
            </div>
            <div className="px-3 py-4 lg:border-r border-gray-500 pr-3">
              <label htmlFor="" className="text-sm font-bold text-gray-400">
                Address
              </label>
              <p className="font-semibold">{memberDetails?.address || "N/A"}</p>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center gap-3 overflow-auto mt-6">
      <div
          onClick={() => setActiveTab(1)}
          className={`border-b-2 ${
            activeTab === 1 ? "border-blue-500" : "border-white"
          } cursor-pointer flex lg:flex-row flex-col lg:items-center gap-2 px-2 py-2`}
        >
          <div
            className={`h-2 w-2 rounded-full ${
              activeTab === 1 ? "bg-blue-500" : "bg-gray-300"
            } flex items-center`}
          ></div>
          <p
            className={`${
              activeTab === 1 ? "text-blue-500" : "text-black"
            } font-semibold`}
          >
            Personal Information
          </p>
        </div>
        <div
          onClick={() => setActiveTab(2)}
          className={`border-b-2 ${
            activeTab === 2 ? "border-blue-500" : "border-white"
          } cursor-pointer flex lg:flex-row flex-col lg:items-center gap-2 px-2 py-2`}
        >
          <div
            className={`h-2 w-2 rounded-full ${
              activeTab === 2 ? "bg-blue-500" : "bg-gray-300"
            } flex items-center`}
          ></div>
          <p
            className={`${
              activeTab === 2 ? "text-blue-500" : "text-black"
            } font-semibold`}
          >
            Family Information
          </p>
        </div>
        <div
          onClick={() => setActiveTab(3)}
          className={`border-b-2 ${
            activeTab === 3 ? "border-blue-500" : "border-white"
          } cursor-pointer flex lg:flex-row flex-col lg:items-center gap-2 px-2 py-2`}
        >
          <div
            className={`h-2 w-2 rounded-full ${
              activeTab === 3 ? "bg-blue-500" : "bg-gray-300"
            } flex items-center`}
          ></div>
          <p
            className={`${
              activeTab === 3 ? "text-blue-500" : "text-black"
            } font-semibold`}
          >
            Spiritual Life Information
          </p>
        </div>
        <div
          onClick={() => setActiveTab(4)}
          className={`border-b-2 ${
            activeTab === 4 ? "border-blue-500" : "border-white"
          } cursor-pointer flex lg:flex-row flex-col lg:items-center gap-2 px-2 py-2`}
        >
          <div
            className={`h-2 w-2 rounded-full ${
              activeTab === 4 ? "bg-blue-500" : "bg-gray-300"
            } flex items-center`}
          ></div>
          <p
            className={`${
              activeTab === 4 ? "text-blue-500" : "text-black"
            } font-semibold`}
          >
            Work/Education Information
          </p>
        </div>
        
        {/* NEW: Member Payments Tab */}
        <div
          onClick={() => setActiveTab(6)}
          className={`border-b-2 ${
            activeTab === 6 ? "border-blue-500" : "border-white"
          } cursor-pointer flex lg:flex-row flex-col lg:items-center gap-2 px-2 py-2`}
        >
          <div
            className={`h-2 w-2 rounded-full ${
              activeTab === 6 ? "bg-blue-500" : "bg-gray-300"
            } flex items-center`}
          ></div>
          <p
            className={`${
              activeTab === 6 ? "text-blue-500" : "text-black"
            } font-semibold`}
          >
            Payments
          </p>
        </div>
      </div>

      {activeTab === 1 && (
        <MemberPersonalDetails memberDetails={memberDetails} />
      )}

      {activeTab === 2 && (
        <MemberFamilyInformation familyDetails={familyDetails} />
      )}
      {activeTab === 3 && (
        <div className="border border-gray-300 py-5 px-5">
          <div className=" grid lg:grid-cols-3 gap-3">
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Previous Church
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.previous_church || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Location of Previous Church
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.previous_church_location || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Pastor of previous church
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.previous_church_pastor || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Reason For Leaving
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.reason_for_leaving_previous_church || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Tithe Card Number
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.tithe_number || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Area of Ministry/Gifting
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.ministry || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Date You Completed Membership Class
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.membership_class_completion_date || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Baptismal Date
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.baptismal_date || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Baptismal Type
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.baptismal_type || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Are you born again
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.born_again ? "Yes" : "No"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Holy spirit baptized?
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.holy_spirit_baptized ? "Yes" : "No"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Speaking in tongues
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.speaking_in_tongues ? "Yes" : "No"}
              </p>
            </div>
          </div>
        </div>
      )}

      {activeTab === 4 && (
        <div className="border border-gray-300 py-5 px-5">
          <div className=" grid lg:grid-cols-3 gap-3">
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Highest Education Qualification
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.highest_education_qualification || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Profession
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.profession || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Occupation
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.occupation || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Place of work
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.place_of_work || "N/A"}
              </p>
            </div>
            <div className="flex flex-col">
              <label htmlFor="" className="font-semibold">
                Employment Status
              </label>
              <p className="px-2 py-1 bg-gray-100 rounded border border-gray-200 ">
                {memberDetails?.employment_status || "N/A"}
              </p>
            </div>
          </div>
        </div>
      )}

      {activeTab === 5 && (
        <MemberAccount user_account={memberDetails?.user_account} />
      )}

      {/* NEW: Member Payments Tab Content */}
      {activeTab === 6 && (
        <MemberPayments
          member_id={member_id}
          incomeTypes={incomeTypes}
          memberPayments={memberPayments}
          getMemberPayments={getMemberPayments}
          gettingPayments={gettingPayments}
        />
      )}
    </div>
  );
};

export default MemberProfile;